<div class="report-issue-container">
    <div class="report-issue-content">
        <form [formGroup]="reportIssueForm" (ngSubmit)="onSubmit()">
            <mat-form-field class="issue" appearance="outline">
                <mat-label>{{'report-issue.desc' | translate}}</mat-label>
                <textarea name="text" [formControl]="textFormControl" autocomplete="off" cdkTextareaAutosize
                    class="issue-txtArea" matInput placeholder="{{'report-issue.desc' | translate}}"></textarea>
            </mat-form-field>
            <button type="submit" mat-raised-button color="primary">
                {{'report-issue.send-issue' | translate}}
                <fa-icon [icon]="faSend"></fa-icon>
            </button>
        </form>
    </div>
</div>